import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { RechargeTransfertComponent } from './views/history/recharge-transfert/recharge-transfert.component';
import { Page404Component } from './extrapages/page404/page404.component';
const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },

  { path: 'history', component: LayoutComponent, loadChildren: () => import('./views/history/history.module').then(m => m.HistoryModule), canActivate: [AuthGuard] },
  
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule) , canActivate: [AuthGuard]},
  {path: '**', component : Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
